import { render } from "./ReportTableElement.vue?vue&type=template&id=022b8679"
import script from "./ReportTableElement.vue?vue&type=script&lang=js"
export * from "./ReportTableElement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__